import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class ModuliPopisService {

  constructor(private _http: Http) { }

  dohvatiSve(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_sve_modulenew', a)
    .map(res => res.json());
  }

  dohvatiSveModuleNew(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_modulenew', a)
    .map(res => res.json());
  }

  editModul_AddNastavnejedinice(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'modul_edit_add_nastavnejedinice', a)
    .map(res => res.json());
  }

  dohvatiAktivneNastavnejedinice(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_aktivne_nastavnejedinice', a)
    .map(res => res.json());
  }

  dohvatiAktivnaPodrucjaznanja(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_aktivna_podrucjaznanja', a)
    .map(res => res.json());
  }

  dodajModul(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'spremi_modulnew', a)
    .map(res => res.json());
  }
  
  urediModul(a: any){
    return this._http.put(AppConfig.apiAdresaSQL + 'uredi_modulnew', a)
    .map(res => res.json());
  }

  obrisiModul(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'obrisi_modulnew', a)
    .map(res => res.json());
  }


}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/moduli-popis/moduli-popis.service.ts